import { CascadiaActionListProps } from "@certn/cascadia/components/action-list/types";
import { Children } from "react";

import { Card } from "../card/Card";
import { Divider } from "../divider/Divider";

interface Props extends CascadiaActionListProps {
  children?: React.ReactNode;
  testID?: string;
  ariaLabel?: string;
  className?: string;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function ActionList(props: Props) {
  const {
    children,
    testID = "action-list",
    className,
    ariaLabel,
    hideBorder,
    showDividers = false,
  } = props;

  return (
    <Card
      testID={testID}
      className={className}
      ariaLabel={ariaLabel}
      hideBorder={hideBorder}
    >
      {Children.map(children, (child, index) => {
        return (
          <>
            {child}
            {showDividers && index < Children.count(children) - 1 && (
              <Divider />
            )}
          </>
        );
      })}
    </Card>
  );
}
